export const formDataStorageKey = 'ProfileSetupFormData';
export const answersDataStorageKey = 'QualificationQuestionsAnswersData';
